<mat-card appearance="outlined" class="cardSearchBy">  
  <h2 style="padding-left:18px;padding-top:5px;">Search Criteria</h2>
  <mat-card-content>
    <form [formGroup]="searchSchoolsForm" class="formSchoolSearch"  > <!--(ngSubmit)="fnSearch()" -->
      <div class="form-group">
        <div class="row">
          <div>
            <mat-form-field class="field-full-width" appearance="fill" tabindex="0">
              <mat-label>School Name</mat-label>
              <input id="schoolName" 
                formControlName="schoolName" 
                type="text" 
                matInput 
                #message 
                maxlength="100"
                minlength="20"
                (keydown)="onKeyDown($event)"                 
                (keyup)="onKeyUp($event)"	
                ngDefaultControl

                class="form-control field-full-width" 
                placeholder="School Name" 
                ><!--                 [(ngModel)]="schoolName"		 pattern="[A-Za-z]" -->
              <mat-hint align="start">
                <span  class="field-full-widthLabels" ><strong>(partial allowed)</strong></span> </mat-hint>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="field-full-width" appearance="fill" tabindex="1">
              <mat-label>Address</mat-label>
              <input id="schoolAddress" formControlName="schoolAddress" type="text" matInput #message maxlength="256" minlength="20"
                class="form-control" placeholder="Address">
              <mat-hint align="start" class="field-full-width" ><span  class="field-full-widthLabels" ><strong>Number and/or Street</strong></span> </mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="row"><div> CDS Code</div></div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <mat-form-field style="width:100%;" tabindex="2" appearance="fill" >
                  <input id="cdsCode1" #cds1 formControlName="cdsCode1" type="tel" (keyup)="onKeyUp($event)"
                    (keydown)="cdsKeyDown($event)" class="form-control" matInput placeholder="xx" maxlength="2">
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <mat-form-field style="width:100%;" tabindex="3" appearance="fill">
                  <input id="cdsCode2" #cds2 formControlName="cdsCode2" type="tel" matInput class="form-control"
                    placeholder="&nbsp;&nbsp;xxxxx" maxlength="5" (keyup)="onKeyUp($event)" (keydown)="cdsKeyDown($event)">
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <mat-form-field style="width:100%;" tabindex="4" appearance="fill">
                  <input id="cdsCode3" #cds3 formControlName="cdsCode3" type="tel" (keyup)="onKeyUp($event)"
                    (keydown)="cdsKeyDown($event)" matInput class="form-control" placeholder="&nbsp;&nbsp;xxxxxxx"
                    autocomplete="off" maxlength="7">
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="row">
              <div>City</div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="field-full-width" tabindex="5" appearance="fill">
                  <input id="city" formControlName="city" #cityfromcds type="text" matInput class="form-control" #message
                    placeholder="Search by City">
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        </div>
 <!-- class="flushLeft "--> 
      <div class="row"> <!--  [ngClass]="{'disable': isLoadingResults}"-->
        <div class="col-8">      
            <button (click)="fnSearch()" 
            mat-raised-button 
            color="primary" 
            (onSearchErrorEvent)="catchSearchError($event)" >Search</button>&nbsp;&nbsp; <!-- type="submit" -->
            <button mat-raised-button color="accent" (click)="fnReset()">Reset</button>
            &nbsp;&nbsp;   
        </div>          
        <div class="col-12"> 
          <textarea class="errorMsg" id="txtErrorMsg" readonly="true" rows="2" style="resize:none;">{{myError}}</textarea>
        </div>
      </div>  
    </form>
  </mat-card-content>
</mat-card>